import theme from '../../base';

const heading = {
  foreground: theme.colors.neutrals.white,
};

export default heading;
